import { render, staticRenderFns } from "./InternalManagementFiles.vue?vue&type=template&id=4ab9ed50"
import script from "./InternalManagementFiles.vue?vue&type=script&lang=js"
export * from "./InternalManagementFiles.vue?vue&type=script&lang=js"
import style0 from "./InternalManagementFiles.vue?vue&type=style&index=0&id=4ab9ed50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports